import React from "react";
import { OriginRoute, DestinyRoute } from "@types";
import { Button } from "@rio-cloud/rio-uikit";

interface InputItemProps {
  label: string;
  value: string;
  iconLeft: string;
  onCheckpointItem?: () => void;
  disabled?: boolean;
}

const Input: React.FC<InputItemProps> = ({ label, value, iconLeft, onCheckpointItem, disabled = false }) => (
  <div className="display-flex align-items-center margin-top-10 margin-bottom-10">
    <div className="width-100pct">
      <label htmlFor="input5">{label}</label>
      <div className="input-group gap-15">
        <span className="input-group-addon">
          <span className={iconLeft} />
        </span>
        <input id="input5" className="form-control" type="text" placeholder="" disabled value={value} />
        <Button 
          bsStyle={Button.PRIMARY} 
          iconOnly 
          iconName="rioglyph rioglyph-checkboxes" 
          disabled={disabled} 
          onClick={onCheckpointItem} 
        />
      </div>
    </div>
  </div>
);

interface StopsSectionProps {
  origin?: OriginRoute;
  destiny?: DestinyRoute;
  stops?: Array<{ note: string; label: string; checkpointId?: string; order?: number; isUnplanned?: boolean }>;
  onClickCheckpoint?: (id: string) => void;
}

export const StopsSection: React.FC<StopsSectionProps> = ({ origin, destiny, stops, onClickCheckpoint }) => (
  <div className="padding-y-10 padding-x-15">
    <Input 
      label="Origem" 
      value={origin?.address?.label || ""} 
      iconLeft="rioglyph rioglyph-start" 
      disabled 
    />
    {stops && stops.length > 0 && (
      <div className="padding-left-20">
        {stops.map((stop, index) => (
          <Input
            key={stop.checkpointId ?? `stop-${index}`}
            label={stop.note}
            value={stop.label}
            iconLeft="rioglyph rioglyph-pushpin"
            // Parada nao programada nao tem checklist para consultar: mantem o botao desabilitado
            // mesmo que o backend devolva um checkpointId vinculado (mesma regra da tela de Desempenho).
            disabled={stop.isUnplanned || !stop.checkpointId}
            onCheckpointItem={() => !stop.isUnplanned && stop.checkpointId && onClickCheckpoint?.(stop.checkpointId)}
          />
        ))}
      </div>
    )}
    <Input 
      label="Destino" 
      value={destiny?.address?.label || ""} 
      iconLeft="rioglyph-finish" 
      disabled 
    />
  </div>
);